import React from 'react'
import { Checkbox, Space } from 'antd'
import {
  FilterCard,
  ClearAllButton,
  FilterHeader,
  StyledDivider,
} from '../../Style'
import { FilterSection, FilterTitle } from '../../../../components/FilterStyles'

const Filter = ({
  deadlineFilter = [],
  assessmentTypeFilter = [],
  onDeadlineChange,
  onAssessmentTypeChange,
  onClearAll,
}) => {
  const deadlineOptions = [
    { label: 'Less than 3 days', value: 'lt3' },
    { label: 'Less than 5 days', value: 'lt5' },
    { label: 'More than 10 days', value: 'gt10' },
  ]

  const assessmentTypeOptions = [
    { label: 'Communication Assessment', value: 'communication' },
    { label: 'Aptitude Assessment', value: 'aptitude' },
    { label: 'Behavioural Assessment', value: 'behavior' },
  ]

  return (
    <FilterCard>
      <FilterHeader>
        <FilterTitle>Filter</FilterTitle>
        <ClearAllButton onClick={onClearAll}>Clear all</ClearAllButton>
      </FilterHeader>
      <StyledDivider />

      <FilterSection>
        <FilterTitle>Deadline</FilterTitle>
        <Checkbox.Group value={deadlineFilter} onChange={onDeadlineChange}>
          <Space direction="vertical">
            {deadlineOptions.map(option => (
              <Checkbox key={option.value} value={option.value}>
                {option.label}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      </FilterSection>

      <FilterSection>
        <FilterTitle>Assessment Type</FilterTitle>
        <Checkbox.Group
          value={assessmentTypeFilter}
          onChange={onAssessmentTypeChange}
        >
          <Space direction="vertical">
            {assessmentTypeOptions.map(option => (
              <Checkbox key={option.value} value={option.value}>
                {option.label}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      </FilterSection>
    </FilterCard>
  )
}

export default Filter